/**
 * Where a support-thread push (chat push with is_support and no project) opens.
 *
 *  - Eleplan staff: the support inbox, where every customer's thread is
 *    answered (chatPush.js promises "admin -> inbox").
 *  - A member: their own support thread.
 *
 * Each in the shell that is mounted: the customer app keeps both under
 * Settings; the partner workspace keeps the member thread in Inbox and the
 * staff inbox under More. Partner detection mirrors AppShell's isPartner.
 */
export type SupportPushRoute = { screen: string; params: { screen: string } };

export function supportPushRoute(state: any): SupportPushRoute {
  const account = state?.session?.account;
  const inCustomerAccess = !!state?.accounts?.current?.via_partner_access;
  const isPartner = !inCustomerAccess
    && account?.partner !== false
    && (!!account?.partner || !!state?.partners?.partner);
  const permissions: unknown = account?.permissions;
  const isStaff = Array.isArray(permissions) && permissions.includes('eleplan-admin');

  if (isStaff) {
    return isPartner
      ? { screen: 'More', params: { screen: 'SupportAdminInbox' } }
      : { screen: 'Settings', params: { screen: 'SupportAdminInbox' } };
  }
  return isPartner
    ? { screen: 'Inbox', params: { screen: 'PartnerSupportChat' } }
    : { screen: 'Settings', params: { screen: 'SupportChat' } };
}
